<div>
  <ng-template [ngIf]="atti && atti?.length > 0">
    <ul class="atti">
      <ng-template ngFor let-atto [ngForOf]="atti" let-i=index>
        <li>
          <div>
            <div *ngIf="!hasAssociaButton" class="row atti-row" style="margin: 10px">
              <p class="col-sm col-md-4">
                <strong>{{atto && atto.tipoAtto ? atto.tipoAtto.descrizione : ''}}</strong>
              </p>
              <p class="col-sm col-md-2">
                <strong>{{atto && atto.provenienza ? atto.provenienza.descrizione : ''}}</strong>
              </p>
              <p class="col-sm col-md-3">
                Data <strong>{{ atto.dataProtocollo ?
                  (atto.dataProtocollo | date:'dd/MM/yyyy'): '' }}</strong>
              </p>
              <p class="col-sm col-md-2">
                N&deg; protocollo: <strong>{{ atto.numeroProtocollo ?
                  atto.numeroProtocollo: '' }}</strong>
              </p>
              <p class="col-sm col-md-1">
                <span
                  [ngClass]="{
                    glyphicon: true,
                    'glyphicon-trash': true
                  }"
                  style="cursor: pointer; margin-top: 10px"
                  (click)="onDelete(i)"
                ></span>
                <a data-toggle="collapse" aria-expanded="true" (click)="openDetail(atto, i)"
                  [attr.aria-controls]="'subcontroparteModalAdd' + i" data-parent="#controparticollapse"
                  class="{{activeIndex === i ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"><span style="display: none">Apri</span></a>
              </p>
            </div>

            <div *ngIf="hasAssociaButton" class="row atti-row" style="margin: 10px">
              <p class="col-sm-2 button-associa">
                <button [disabled]="associaDisabled" class="btn btn-primary associa"
                  (click)="onAssocia(i)">Associa</button>
              </p>
              <p class="col-sm-4">
                <strong>{{ atto.tipoAtto.label }}</strong>
              </p>
              <p class="col-sm-3">
                Data pubblicazione<br> <strong>{{ atto.dataPubblicazione ?
                  (atto.dataPubblicazione | date:'dd/MM/yyyy'): '' }}</strong>
              </p>
              <p class="col-sm-3">
                Data deposito<br> <strong>{{ atto.dataDeposito ?
                  (atto.dataDeposito | date:'dd/MM/yyyy'): '' }}</strong>
              </p>
            </div>
          </div>
          <!--<div class="atti-content">
            <ngb-accordion #acc="ngbAccordion">
              <ngb-panel id="attolistmember{{ i }}">
                <ng-template ngbPanelContent>
                  <form *ngIf="!hasAssociaButton">
                    <div class="data_opzioni">
                      <a href="javascript:void(0)" (click)="onEdit(i)" *ngIf="hasEditButton">
                        <span class="glyphicon glyphicon-pencil"></span>
                      </a>
                    </div>
                    <div class="row">

                      <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Tipo atto'" [valueInput]="atto.tipoAtto?.descrizione"></div>
                    </div>
                    <div class="row">
                      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
                        [labelInput]="'Provenienza'" [valueInput]="atto.provenienza?.descrizione"></div>
                      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
                        [labelInput]="'Data deposito'" [valueInput]="atto.dataDeposito"></div>
                      <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'"
                        [labelInput]="'Data notifica'" [valueInput]="atto.dataNotifica"></div>
                    </div>
                    <div class="row">
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'boolean'"
                        [labelInput]="'Titolo esecutivo'" [valueInput]="atto.titoloEsecutivo"></div>
                      <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
                        [labelInput]="'Data apposizione formula esecutiva'"
                        [valueInput]="atto.dataApposizioneFormulaEsecutiva"></div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 bloccodati">
                        <p>
                          <label class="col-sm-12">Note</label> <span class="longtext">{{ atto.note
                            }}</span>
                        </p>
                      </div>
                    </div>
                  </form>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>-->
          <ul class="{{activeIndex === i ? 'collapsed' : 'collapse'}} subcontroparte">
            <li>
              <form *ngIf="!hasAssociaButton">
                <div class="row">
                  <div labelTextInput class="col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Tipo atto'"
                    [valueInput]="atto.tipoAtto?.descrizione"></div>
                  <!-- <div class="col-sm-1">
                    <a href="javascript:void(0)" (click)="onEdit(i)" *ngIf="hasEditButton">
                      <span class="glyphicon glyphicon-pencil"></span>
                    </a>
                  </div> -->
                </div>
                <div class="row">
                  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'" [labelInput]="'Provenienza'"
                    [valueInput]="atto.provenienza?.descrizione"></div>
                  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data deposito'"
                    [valueInput]="atto.dataDeposito"></div>
                  <div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'date'" [labelInput]="'Data notifica'"
                    [valueInput]="atto.dataNotifica"></div>
                </div>
                <div class="row">
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'boolean'"
                    [labelInput]="'Titolo esecutivo'" [valueInput]="atto.titoloEsecutivo"></div>
                  <div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'date'"
                    [labelInput]="'Data apposizione formula esecutiva'"
                    [valueInput]="atto.dataApposizioneFormulaEsecutiva"></div>
                </div>
                <div class="row">
                  <div class="col-sm-12 bloccodati">
                    <p>
                      <label class="col-sm-12">Note</label> <span class="longtext">{{ atto.note
                        }}</span>
                    </p>
                  </div>
                </div>
                <div class="row mr-5">
                  <p class="col-sm-3 col-sm-offset-9 col-xs-4">
                    <button type="button" class="btn btn-primary btn-block" (click)="onEdit(i)" *ngIf="hasEditButton">Modifica dati</button>
                  </p>
                </div>
              </form>
            </li>
          </ul>
        </li>
      </ng-template>
    </ul>
  </ng-template>
  <div class="tab-content" *ngIf="atti && atti.length == 0 && !hasAssociaButton">
    <p>Nessun atto è stato ancora inserito.</p>
  </div>
</div>
